import { COMMON } from "..";
import { addClass, removeClass, makeEl } from "../../common/Utils";
import { AbsShare } from "./AbsShare";
import BreakpointFeature from "./feature/Breakpoint";
import { BtnShareTrigger } from "./feature/BtnShareTrigger";
import { BtnShareTriggerWithShareLayer } from "./feature/BtnShareTriggerWithShareLayer";
import { CopyText } from "./socials/CopyText";
import { Facebook } from "./socials/Facebook";
import { Line } from "./socials/Line";
import { Twitter } from "./socials/Twitter";

const IS_OPEN_CLASS = 'is-open';

const mapSocialNameToConstructor = {
    facebook: Facebook,
    line: Line,
    copy: CopyText,
    twitter: Twitter
}

export class ShareLayer extends AbsShare {
    public ElContainer!: HTMLElement;
    public ElWrap!: HTMLElement;
    private ElDim: HTMLElement | null = null;
    private ElTitle!: HTMLElement;
    private ElBtnClose!: HTMLElement;
    private ElShareList!: HTMLElement;
    private ElShareItem!: HTMLButtonElement;
    private ElTriggerBtn!: HTMLButtonElement;
    breakpoint: BreakpointFeature | null = null;
    btnShareTrigger: BtnShareTrigger | null = null;
    public IS_OPEN = false;

    constructor(private optionMap: ShareOptionMap){
        super();

        this.setBreakpoint();
        this.create();
    }

    //  breakpoint 설정
    setBreakpoint(){
        // breakpoint 가 있으면
        if(BreakpointFeature.hasBreakpoints(Object.keys(this.optionMap))){
            // breakpoint 인스턴스 생성
            this.breakpoint = new BreakpointFeature(Object.keys(this.optionMap));
            // breakpoint 이벤트 세팅
            this.breakpoint.onChangeBreakpoint(() => this.onChangeBreakpointCallback())
        }
    }

    onChangeBreakpointCallback(){
        this.remove();

        this.create();
        this.IS_OPEN && this.open();
    }

    get option(){
        if(this.breakpoint){
            return this.optionMap[this.breakpoint.currentBreakPoint];
        }else{
            return this.optionMap[COMMON];
        }
    }

    setBtnShareTrigger() {
        const BtnShareTriggerOption = this.option.btnShareTrigger

        if(!BtnShareTriggerOption) return

        if( BtnShareTrigger.canUse(BtnShareTriggerOption)){
            this.btnShareTrigger = new BtnShareTrigger(this, BtnShareTriggerOption);
        }
    }

    open(): void {
        this.IS_OPEN = true;

        this.ElDim && (document.querySelector('body')!.style.overflow = 'hidden');
        this.ElDim && addClass(this.ElDim, IS_OPEN_CLASS);

        addClass(this.ElContainer, IS_OPEN_CLASS);
    }

    close(): void {
        this.IS_OPEN = false;

        this.ElDim && (document.querySelector('body')!.style.overflow = '');
        this.ElDim && (removeClass(this.ElDim, IS_OPEN_CLASS));

        removeClass(this.ElContainer, IS_OPEN_CLASS);
    }

    toggle(){
        if(this.IS_OPEN){
            this.close();
        }else{
            this.open();
        }
    }

    remove(){
        this.ElContainer.remove();

        this.ElDim?.remove();
        this.ElDim = null;

        this.btnShareTrigger?.remove();
        this.btnShareTrigger = null;
    }

    create(){
        this.#makeElement();
        this.#addCloseEvent()

        this.setBtnShareTrigger();
    }

    #makeElement(){
        // shareDimmed 만들고 -> body에 붙이고
        this.option.dimmed && this.#makeElShareDimmed();

        // shareContainer 만들고 -> body에 붙이고
        this.#makeElShareContainer();

        // shareWrapper 만들고 -> shareContainer에 붙이고
        this.#makeElShareWrapper();

        // shareTitle 만들고 -> body에 붙이고
        this.option.title && this.#makeShareTitle();

        // uList 만들고 -> shareContainer 에 붙이고
        this.#makeElShareList();

        // 각 sns 공유 버튼 만들고 -> shareList 에 붙이고
        this.#makeShareItem();

        // btnClose 만들고 -> shareContainer에 붙이고
        this.#makeBtnClose();
    }

    #makeElShareContainer(){
        this.ElContainer = makeEl('div', document.querySelector('body')!, {class: 'ncui-share'});
    }
    #makeElShareWrapper(){
        this.ElWrap = makeEl('div',this.ElContainer, {class: 'ncui-share-wrapper'});
    }

    #makeShareTitle(){
        this.ElTitle = makeEl('p', this.ElWrap, {class: 'ncui-share-title'}, this.option.title!);
    }

    #makeElShareList(){
        this.ElShareList = makeEl('div', this.ElWrap, {class: 'ncui-share-list'});
    }

    #makeShareItem(){

        let ElShareItemWrap: HTMLDivElement;

        return this.option.snsOrder.map((socialName, idx) => {

            if(idx % 3 === 0) {
                ElShareItemWrap = makeEl('div', this.ElShareList, {class: 'ncui-share-item-wrap'});
            }

            return new mapSocialNameToConstructor[socialName](ElShareItemWrap, this.option);
        })
    }

    #makeBtnClose(){
        this.ElBtnClose = makeEl('button', this.ElWrap, {class: 'ncui-share-close'});
    }

    #makeElShareDimmed(){
        this.ElDim = makeEl('div', document.querySelector('body')!, {class:'ncui-share-dim'})//딤생성
    }

    #addCloseEvent(){
        this.ElBtnClose.addEventListener('click', () => this.close());
        this.ElDim?.addEventListener('click', () => this.close());
    }
}
